import { Link } from "react-router-dom";
import { MapPin, Clock, Phone, InstagramLogo, FacebookLogo } from "@phosphor-icons/react";
import { WHATSAPP } from "./PublicNav";

export default function PublicFooter() {
  return (
    <footer className="bg-zinc-950 text-zinc-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-11 h-11 rounded-xl bg-brand text-white flex items-center justify-center font-display font-black text-xl">JR</div>
            <div>
              <div className="font-display text-lg font-bold text-white">Tacos El Paisa</div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-zinc-500">San Cristóbal Ecatepec</div>
            </div>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed">La tradición que se deshace en tu boca. Sabor, calidad y la mejor atención.</p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Visítanos</div>
          <div className="flex items-start gap-2 text-sm mb-3"><MapPin size={18} className="mt-0.5 text-brand" weight="fill" /><span>López Rayón 43, San Cristóbal Ecatepec, Edo. Méx.</span></div>
          <div className="flex items-start gap-2 text-sm mb-3"><Clock size={18} className="mt-0.5 text-brand" weight="fill" /><span>Lun–Dom · Hasta las 12 de la noche</span></div>
          <a href={WHATSAPP} target="_blank" rel="noreferrer" className="flex items-start gap-2 text-sm hover:text-white"><Phone size={18} className="mt-0.5 text-brand" weight="fill" /><span>WhatsApp directo</span></a>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Explora</div>
          <ul className="space-y-2 text-sm">
            <li><Link className="hover:text-white" to="/menu">Carta Digital</Link></li>
            <li><Link className="hover:text-white" to="/historia">Nuestra Historia</Link></li>
            <li><Link className="hover:text-white" to="/galeria">Galería</Link></li>
            <li><Link className="hover:text-white" to="/ubicacion">Cómo Llegar</Link></li>
            <li><Link className="hover:text-white text-zinc-500" to="/admin/login">Acceso Personal</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 mb-4">Síguenos</div>
          <div className="flex gap-3">
            <a href="#" className="w-10 h-10 rounded-full border border-zinc-800 flex items-center justify-center hover:border-brand hover:text-brand"><InstagramLogo size={20} weight="bold" /></a>
            <a href="#" className="w-10 h-10 rounded-full border border-zinc-800 flex items-center justify-center hover:border-brand hover:text-brand"><FacebookLogo size={20} weight="bold" /></a>
          </div>
          <div className="mt-6 text-xs text-zinc-500">★★★★☆ <span className="text-zinc-300">4.4</span> en reseñas</div>
        </div>
      </div>
      <div className="border-t border-zinc-900">
        <div className="max-w-7xl mx-auto px-6 py-6 text-xs text-zinc-500 flex justify-between flex-wrap gap-3">
          <div>© {new Date().getFullYear()} J.R. Tacos El Paisa · Hecho con tradición.</div>
          <div>Taquería 360 · Versión 1.0</div>
        </div>
      </div>
    </footer>
  );
}
